export const flex = {
  patterns: {
    string: '{{value}}',
  },
  properties: 'flex',
};

export const flexDirection = {
  patterns: {
    string: '{{value}}',
  },
  properties: 'flexDirection',
};

export const flexFlow = {
  patterns: {
    number: '{{value}}',
    string: '{{value}}',
  },
  properties: 'flexFlow',
};

export const flexGrow = {
  patterns: {
    number: '{{value}}',
  },
  properties: 'flexGrow',
};

export const flexShrink = {
  patterns: {
    number: '{{value}}',
  },
  properties: 'flexShrink',
};

export const flexWrap = {
  patterns: {
    string: '{{value}}',
  },
  properties: 'flexWrap',
};
